export default "__VITE_ASSET__C743KVIg__"